import { render, staticRenderFns } from "./modalOpenHistory.vue?vue&type=template&id=40f21702&scoped=true&"
import script from "./modalOpenHistory.vue?vue&type=script&lang=js&"
export * from "./modalOpenHistory.vue?vue&type=script&lang=js&"
import style0 from "./modalOpenHistory.vue?vue&type=style&index=0&id=40f21702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f21702",
  null
  
)

export default component.exports